import dayjs from 'dayjs';
import { useMemo } from 'react';
import { Cell } from 'react-table';
import { IVendor } from 'wisestep-api';
import {
  WsTypography,
  WsTypoColors,
  WsChip,
  WsChipVariants,
  WsDotIcon,
  WsDotColors,
  WsDataTable,
} from 'wisestep-base';
export type IconProps = {
  statusColor: string;
};
interface VendorTableProps {
  data?: IVendor[];
}
const VendorTable = ({ data }: VendorTableProps) => {
  const formattedDate = (date: string): string => dayjs(date).format('DD/MM/YYYY');

  const vendorListData = useMemo(
    () =>
      data?.map((vendor) => ({
        name: vendor.name,
        email: vendor.email,
        emailStatus: vendor.emailBounceStatus,
        invite: vendor.subscriptionStatus,
        uploadedBy: vendor.createdBy,
        uploadedOn: formattedDate(vendor.createdOn?.toString() ?? ''),
      })),
    [data]
  );
  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Email',
        accessor: 'email',
        Cell: (cell: Cell) => <WsTypography color={WsTypoColors.BLACK}>{cell.value}</WsTypography>,
      },
      {
        Header: 'Email Status',
        accessor: 'emailStatus',
        Cell: (cell: Cell) => (
          <WsChip
            value={cell.value}
            variant={
              cell.value === 'Valid'
                ? WsChipVariants.SUCCESS
                : cell.value === 'Invalid'
                ? WsChipVariants.INVALID
                : WsChipVariants.UNKNOWN
            }
          />
        ),
      },
      {
        Header: 'Opt-in Email Invite',
        accessor: 'invite',
        Cell: (cell: Cell) => (
          <WsDotIcon
            color={cell.value === 'Sent' ? WsDotColors.GREEN : WsDotColors.YELLOW}
            value={cell.value}
          />
        ),
      },
      {
        Header: 'Uploaded by',
        accessor: 'uploadedBy',
        Cell: (cell: Cell) => <WsTypography color={WsTypoColors.BLACK}>{cell.value}</WsTypography>,
      },
      {
        Header: 'Uploaded on',
        accessor: 'uploadedOn',
        Cell: (cell: Cell) => <WsTypography color={WsTypoColors.BLACK}>{cell.value}</WsTypography>,
      },
    ],
    []
  );

  return (
    <WsDataTable
      columns={columns}
      data={vendorListData || []}
      totalDataItems={10}
      selectable={false}
      boldItems={['name', 'invite']}
      pageable={false}
    />
  );
};
export default VendorTable;
